<template>
  <div class="header-overlay-container announcement_mobile_pop" :class="announcementOpen ? '' : 'hidden'">
    <div class="announcement-mweb">
      <div class="header-overlay__top-bar an-header">
        <div class="w-full ">
          <a href="https://wkfe.vicosys.com.hk/en/home" data-ga-group="menu_bar" data-ga-element="logo"><img src="https://webmedia-uat.westkowloon.hk/wk_logo_white.png" alt="wk logo black" class="headerLogo" style="width: 129px; height: 65px;"></a>
        </div>
        <button class="btn-close-2" @click="toggleAnnouncement">
          <img alt="menu_slash" loading="lazy" width="40" height="40" decoding="async" data-nimg="1" class="fill-black" src="/images/icons/close.svg" style="color: transparent;">
        </button>
      </div>
      <div class="overflow-y-scroll w-full ">
        <div class="flex flex-col w-full lg:max-w-[800px] mx-auto relative h-full">
          <div class="font-bold relative self-start uppercase text-white text-[30px] lg:text-[36px] mt-[20px] lg:mt-[8px] mb-[24px] undefined">{{ $t("announcement.title") }}</div>
          <template v-if="announcements.announcements && announcements.announcements[0]">
            <div class="mt-2 w-full md:max-h-[calc(50vh-260px)]  h-[75%] relative !overflow-y-scroll flex flex-col">
              <template v-for="(announcement, index) in announcements.announcements" :key="announcement.uuid">
                <div class="announcement_box mb-6 px-6 w-full border-l-[1px] flex flex-1 flex-col border-white font-light" ref="announcement_box">
                  <div class="underline break-all text-white anno-link" @click="clearUnreadHint(announcement.uuid, announcement.path)">{{ announcement.title }}</div>
                  <template v-if="announcement.created"><div class="mt-4 text-sm annoTime" v-t="setTimeStr(announcement.created)"></div></template>
                </div>
              </template>
            </div>
            <button class="border-[1px] border-white rounded-full mt-6 btnStyle1 self-start !px-16 !mb-0">{{ $t("announcement.view_all") }}</button>
          </template>
          <template v-else><h3>{{ $t("announcement.null_str") }}</h3></template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import HeaderLogo from "@/components/layout/header/icons/HeaderLogo"

export default {
  name: 'header-announcement',
  components: {
    HeaderLogo,
  },
  data() {
    return {
      _storage: "",
      _readlist: {},
      key: 'has_read_announcement',
    };
  },
  updated() {
    this.unread = 0;
    this.setUnread(this.unread);
    this._readlist = localStorage.getItem(this.key) ? JSON.parse(localStorage.getItem(this.key)) : {};
    if(this.announcements.announcements && this.announcements.announcements[0]){
      this.checkAnnoUnread();
    }
  },
  props: {
    announcementOpen: {
      type: Boolean,
      required: true
    },
    unread: {
      type: Number,
      required: true,
    },
  },
  methods: {
    toggleAnnouncement() {
      console.log("toggleAnnouncement", this.announcements.announcements);
      this.$emit('toggleAnnouncement');
    },
    setUnread(_unread) {
      this.$emit('setUnread', _unread)
    },
    toTwoChar(value) {
      return ('0' + value).slice(-2);
    },
    setTimeStr(time) {
      var timeStr = "";
      if (time.indexOf("-") >= 0) {
        let formatedDate = new Date(time);
        let yy = formatedDate.getFullYear();
        let dd = this.toTwoChar(formatedDate.getDate());
        let mm = this.toTwoChar(formatedDate.getMonth() + 1);
        timeStr = dd + "." + mm + "." + yy;
      }
      return timeStr;
    },
    checkIsExpired(time) {
      return (new Date()).getTime() >= time;
    },
    checkIsExist(announcementId) {
      var getTime = 0;
      if (this._readlist[announcementId]) {
        getTime = this._readlist[announcementId].ttl;
      }
      return getTime;
    },
    checkAnnoUnread() {
        let annos = this.announcements.announcements;
        for (let i = 0; i < annos.length; i++) {
          let ele = annos[i];
          let aid = ele.uuid;
          if (aid && Object.keys(this._readlist).length > 0) {
            let time = this.checkIsExist(aid);
            if (time) {
              let isExpired = this.checkIsExpired(time);
              if (isExpired) {
                this.unread++;
              }
            } else {
              this.unread++;
            }
          } else {
            this.unread++;
          }
          this.setUnread(this.unread);
        }
    },
    setRead(id) {
      let date = new Date();
      date.setDate(date.getDate() + 7);
      let time = date.getTime();
      let reduce = false;
      let timeIsExist = this.checkIsExist(id);
      if (Object.keys(this._readlist).length > 0 && timeIsExist > 0) {
        for (let index in this._readlist) {
          if (index == id) {
            this._readlist[id] = { "ttl": time };
            reduce = true;
          }
        };
      } else {
        this._readlist[id] = { "ttl": time };
        reduce = true;
      }
      if (reduce) {
        this.unread--;
        this.setUnread(this.unread);
      }
    },
    clearUnreadHint(announcementId, ahref) {
      if (Object.keys(this._readlist).length > 0) {
        let time = this.checkIsExist(announcementId);
        if (time) {
          if (this.checkIsExpired(time)) {
            this.setRead(announcementId);
          }
        } else {
          this.setRead(announcementId);
        }
      } else {
        this.setRead(announcementId);
      }
      localStorage.setItem(this.key, JSON.stringify(this._readlist));
      document.location.href = process.env.VUE_APP_WK_FRONT_END_URL + ahref;
    }
  },
  computed: {
    headerLogoStyle() {
        return {
            width: `${this.isMobile ? this.mobileLogoWidth : this.desktopLogoWidth}px`,
            height: `${this.isMobile ? this.mobileLogoHeight : this.desktopLogoHeight}px`,
        };
    },
    ...mapState(['announcements', "blackSiteLogo", "whiteSiteLogo", "textLogo", "logoLink", "desktopLogoHeight", "desktopLogoWidth", "mobileLogoHeight", "mobileLogoWidth"]),
  },
}
</script>